<dx-tabs
  class="ag-shared-tabs {{ cssClass }}"
  [width]="width"
  [dataSource]="dataSource"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="selectedIndexChange.emit($event)"
  (onItemClick)="onItemClick.emit($event)"
>
</dx-tabs>
